import permissionSelectRenderer from './permissionSelectRenderer';

export default permissionSelectRenderer;
